import SplitSection from "../components/SplitSection";
import SplitSectionReversed from "../components/SplitSectionReversed";



const Food = () => {
    return (
        <>
        <SplitSection />
        <SplitSectionReversed />
        </>
    )
}

export default Food;